import * as React from "react";
import { ResponsiveBar } from "@nivo/bar";
import graphData from "../../../assets/data/samplebargraphdata";

export default class StackedBarGraph extends React.Component {
  state = {};
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    // actual data
  }
 
  render() {
    return (
      <div style={{ width: "100%", height: "500px" }} className="nivocontainer">
        <ResponsiveBar
          data={this.props.data}
          keys={["total", "No Alert"]}
          indexBy={"day"}
          margin={{ top: 30, right: 70, bottom: 70, left: 70 }}
          padding={0.3}
          groupMode="grouped"
          colors={["#18ee97", "#feb743", "#f56f3f", "#8e0666", "#e7233d"]}
          theme={{

            axis: {
              fontSize: "14px",
              tickColor: "#eee",
              ticks: {
                line: {
                  stroke: "#e7233d"
                },
                text: {
                  fill: "#ffffff"
                }
              },
              legend: {
                text: {
                  fill: "#aaaaaa",
                  fontFamily: "Roboto Condensed",
                  fontWeight: 'bold',
                  fontSize: '16px'
                }
              }
            },
            grid: {
              line: {
                stroke: "#999"
              }
            }
          }}
       
          borderColor={ "#fff" }
          axisTop={null}
          axisRight={null}
          axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: this.props.bottomlegend,
            legendPosition: "middle",
            legendOffset: 32
          }}
          axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: this.props.leftlegend,
            legendPosition: "middle",
            legendOffset: -40
          }}
          labelSkipWidth={12}
          labelSkipHeight={12}
          labelTextColor={"#1a1a1a"}
          legends={[
            {
            itemTextColor: "#fff",
              dataFrom: "keys",
              anchor: "bottom",
              direction: "row",
              justify: false,
            //   translateX: 120,
              translateY: 80,
              itemsSpacing: 5,
              itemWidth: 100,
              itemHeight: 30,
              itemDirection: "left-to-right",
              itemOpacity: 0.85,
              symbolSize: 15,
              effects: [
                {
                  on: "hover",
                  style: {
                    itemOpacity: 1
                  }
                }
              ]
            }
          ]}
          animate={true}
          motionStiffness={90}
          motionDamping={15}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/DataViz/Admin/stackedBarGraph.Component.js